import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";
const {
  colors: { ui },
} = constants;
const greyLight = ui.neutral[100];
const greyExtraLight = ui.neutral[25];
const greyLightBorder = `1px solid ${ui.neutral[100]}`;

export const tableCss: CSSObject = {
  TableControlPanel: {
    summaryContainer: {
      ">div:first-of-type": {
        display: "none",
      },
    },
  },

  tableContainer: {
    zIndex: 1,
    "&:after": {
      borderColor: greyLight,
    },
  },

  scrollContainer: {
    backgroundImage: "none",
  },

  table: {
    minWidth: "100%",
    thead: {
      th: {
        verticalAlign: "top",
      },
    },
    tbody: {
      tr: {
        ":nth-of-type(odd)": {
          backgroundColor: greyExtraLight,
          th: {
            backgroundColor: greyExtraLight,
          },
        },
      },
    },
    th: {
      textDecoration: "underline",
    },
    "td, th": {
      minWidth: "220px",
      height: "64px",
      padding: "8px 16px",
      textAlign: "left",
      borderBottom: greyLightBorder,
      fontWeight: 400,
      fontSize: "14px",

      button: {
        textAlign: "left",
        lineHeight: "150%",
        alignItems: "start",
        justifyContent: "space-between",
        width: "100%",
      },

      ":first-of-type": {
        button: {
          fontWeight: 700,
        },
      },
    },
  },

  TablePagination: {
    root: {
      boxShadow: "none",
      borderWidth: "1px",
    },
  },
};
